import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

/** Coloured accent bar + label / value / sub-line. Used in every KPI strip. */
export default function KpiCard({ label, value, sub, accent = 'var(--s1)', delta }) {
  return (
    <Paper
      sx={{
        background: 'var(--card)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        p: '16px',
        boxShadow: 'var(--shadow)',
        position: 'relative',
        overflow: 'hidden',
        height: '100%',
      }}
    >
      <Box sx={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 4, background: accent }} />
      <Box className="lbl" sx={{ fontSize: '10.5px', letterSpacing: '.08em' }}>{label}</Box>
      <Box sx={{ fontFamily: 'var(--disp)', fontWeight: 700, fontSize: 30, letterSpacing: '-.02em', mt: 1 }}>
        {value}
      </Box>
      <Box sx={{ fontSize: 12, color: 'var(--ink-2)', mt: '5px' }}>
        {sub}{' '}
        {delta != null && (
          <>
            <Box
              component="span"
              sx={{
                fontFamily: 'var(--mono)',
                fontWeight: 700,
                fontSize: 11,
                color: delta >= 0 ? 'var(--good-ink)' : 'var(--crit)',
              }}
            >
              {delta >= 0 ? '▲' : '▼'} {Math.abs(delta).toFixed(1)}%
            </Box>{' '}
            vs prev
          </>
        )}
      </Box>
    </Paper>
  );
}

/**
 * KPI strip on the 12-column grid. `size` is passed straight to MUI Grid so a
 * 5-up row lands on 2.4 columns each (12 / 5) at desktop width.
 */
export function KpiGrid({ items, columns = 5 }) {
  const lg = 12 / columns;
  return (
    <Grid container spacing={1.75} sx={{ mb: 2.25 }}>
      {items.map((it, i) => (
        <Grid key={i} size={{ xs: 12, sm: 6, md: 4, lg }}>
          <KpiCard {...it} />
        </Grid>
      ))}
    </Grid>
  );
}
